import { createSelector } from '@reduxjs/toolkit'
import _groupBy from 'lodash/groupBy'
import _identity from 'lodash/identity'

import { FILE_TYPE_SUBMITTED_RETURN } from '../constants'

const pluckQuarterlyTaxReturnsAnnualSummaryId = (_, { quarterlyTaxReturnsAnnualSummaryId }) =>
    quarterlyTaxReturnsAnnualSummaryId

export const getQuarterlyTaxReturnsAnnualSummaryFilesSlice = (state) => state.quarterlyTaxReturnsAnnualSummaryFiles
const getQuarterlyTaxReturnsAnnualSummaryFiles = (state) => getQuarterlyTaxReturnsAnnualSummaryFilesSlice(state).items

export const getQuarterlyTaxReturnsAnnualSummaryFilesByQuarterlyTaxReturnsAnnualSummaryId = createSelector(
    [getQuarterlyTaxReturnsAnnualSummaryFiles, pluckQuarterlyTaxReturnsAnnualSummaryId],
    (quarterlyTaxReturnsAnnualSummaryFiles, quarterlyTaxReturnsAnnualSummaryId) =>
        quarterlyTaxReturnsAnnualSummaryFiles.filter(
            (file) => file.quarterlyTaxReturnsAnnualSummaryId === quarterlyTaxReturnsAnnualSummaryId
        )
)
export const getQuarterlyTaxReturnsAnnualSummaryFilesByQuarterlyTaxReturnsAnnualSummaryIdGroupedByType = createSelector(
    [getQuarterlyTaxReturnsAnnualSummaryFilesByQuarterlyTaxReturnsAnnualSummaryId],
    (quarterlyTaxReturnsAnnualSummaryFiles) => _groupBy(quarterlyTaxReturnsAnnualSummaryFiles, 'fileType')
)

export const getFinalQuarterlyTaxReturnsAnnualSummaryFiles = createSelector(
    [getQuarterlyTaxReturnsAnnualSummaryFilesByQuarterlyTaxReturnsAnnualSummaryId],
    (quarterlyTaxReturnsAnnualSummaryFilesByQuarterlyTaxReturnsAnnualSummaryId) => {
        const finalQuarterlyTaxReturnsAnnualSummaryFiles =
            quarterlyTaxReturnsAnnualSummaryFilesByQuarterlyTaxReturnsAnnualSummaryId.filter(
                (item) => item.fileType === FILE_TYPE_SUBMITTED_RETURN
            ) || {}

        const hasFinalQuarterlyTaxReturnsAnnualSummaryFile = finalQuarterlyTaxReturnsAnnualSummaryFiles.length > 0

        return {
            finalQuarterlyTaxReturnsAnnualSummaryFiles,
            hasFinalQuarterlyTaxReturnsAnnualSummaryFile,
        }
    }
)

export default createSelector([getQuarterlyTaxReturnsAnnualSummaryFilesSlice], _identity)
